/**
 * Comment Form
 *
 *
 * Events:
 *
 *  @publishes comment-section-selected <comment-section-label>
 *
 */

var sw = require('./../sw');
var ShapewaysFormView = require('./ShapewaysFormView');
var _ = require('underscore');
var $ = require('./../../sw-jquery/sw-jquery');

var CommentForm = ShapewaysFormView.extend({

  waitingClass: 'waiting',

  events: {
    'change [data-sw-comment-form-fileinput]': 'pictureChanged',
    'change [data-sw-comment-form-text]': 'textChanged',
    'submit [data-sw-comment-form]': 'onSubmit',
    'click [data-sw-comment-delete]': 'removeComment',
    'click [data-sw-comment-reply]': 'reply',
    'click [data-sw-comment-tab]': 'tabClick',
    'click [data-sw-comments-show-more]': 'showTruncatedComments'
  },

  swAttrs: {
    commentForm: 'data-sw-comment-form',
    imagePreview: 'data-sw-comment-form-image-preview',
    fileInput: 'data-sw-comment-form-fileinput',
    msgInfo: 'data-sw-comment-info',
    submitButtons: 'data-sw-comment-form-button',
    textInput: 'data-sw-comment-form-text',
    commentRow: 'data-sw-comment-row',
    commentFormWrapper: 'data-sw-comment-form-wrapper',
    commentTabWrapper: 'data-sw-comment-tab-wrapper',
    commentSection: 'data-sw-comment-section'
  },

  initialize: function() {
    this.listenTo(this, 'image-loaded', this.repaint, this);
    this.filePreviewUrl = '';
    this.currentMode = this.$('[data-sw-comment-tab-wrapper].selected').data('swCommentTabWrapper');
  },

  serialize: function() {
    var $form = this.cachedElements.$commentForm;

    var values = ShapewaysFormView.prototype.serialize.apply(this, [$form]);

    if (!window.FormData) {
      return values;
    }

    var data = new FormData();
    _.each(values, function(value, key) {
      data.append(key, value);
    });

    var file = this.cachedElements.$fileInput[0] && this.cachedElements.$fileInput[0].files[0];
    if (file) {
      data.append(this.cachedElements.$fileInput.attr('name'), file);
    }

    return data;
  },

  onSubmit: function(e) {
    e.preventDefault();

    var params = {
      success: _.bind(this.addSuccess, this),
      complete: _.bind(this.onComplete, this),
      $form: this.cachedElements.$commentForm,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false
    };

    if (this.currentMode === 'beta-comments') {
      params.url = this.cachedElements.$commentForm.data('swCommentFormSupporterAction');
    }

    //to prevent double submission
    if(!$(e.currentTarget).hasClass(this.waitingClass)) {
      this.cachedElements.$submitButtons.addClass(this.waitingClass);
      this.inlinePost(params);
    }
  },

  onComplete: function() {
    this.repaint(_.bind(function() {
      this.cachedElements.$submitButtons.removeClass(this.waitingClass);
    }, this));

  },

  addError: function(error) {
    this.cachedElements.$msgInfo.html(error).removeClass('hidden');
  },

  addSuccess: function(data) {

    if (data.error) {

      this.repaint(_.bind(function() {
        this.addError(data.error);
      }, this));

      return;
    }

    if (!data.html) {
      return;
    }

    this.replaceWith(data.html);
  },

  render: function() {
    if (this.filePreviewUrl) {
      this.cachedElements.$imagePreview.attr('src', this.filePreviewUrl);
    }

    this.cachedElements.$imagePreview.addClass('visible');
  },

  getFile: function() {
    //if HTML5 is supported
    if (window.FileReader && window.File) {
      return this.cachedElements.$fileInput[0].files[0];
    }

    return this.cachedElements.$fileInput.val();
  },

  pictureChanged: function() {
    var maxSize = this.cachedElements.$fileInput.data('swCommentFormFileinput');
    var file = this.getFile();
    if (file.size && (file.size > maxSize)) {
      window.alert('File exceeds maximum allowed size');
      this.cachedElements.$fileInput.val('');
      this.filePreviewUrl = '';
      this.repaint();

      return;
    }

    this.previewFile();
  },

  previewFile: function() {
    var file = this.getFile();

    if (file.size) {
      var reader = new FileReader();
      reader.onload = _.bind(function(e) {
        this.filePreviewUrl = e.target.result;
        this.repaint();
      }, this);

      reader.readAsDataURL(file);

    } else {
      this.filePreviewUrl = '/rrstatic/img/comment-photo-default.png';
      this.repaint();
    }
  },

  removeComment: function(e) {
    e.preventDefault();

    var $target = $(e.target);
    var commentId = $target.data('swCommentDelete');
    var commentForm = this;
    $.ajax({
      url: $target.attr('href'),
      dataType: 'json',
      success: _.bind(function(data) {
        if (!data) {
          return;
        }

        this.repaint(function() {
          $('[' + commentForm.swAttrs.commentRow + '=' + commentId + ']').remove();
        });
      }, this)
    });
  },

  /**
   * Displays comments that were initially hidden for truncation.
   * @param  {object} e event object.
   */
  showTruncatedComments: function showTruncatedComments(e) {
    $(e.currentTarget).addClass('sw--is-hidden');
    this.cachedElements.$commentRow.removeClass('sw--is-hidden');
  },

  reply: function(e) {
    e.preventDefault();

    var str = $(e.target).data('swCommentReply');
    var val = this.cachedElements.$textInput.val() || '';

    this.cachedElements.$textInput.focus().val(str + val);
  },

  tabClick: function(e) {
    e.preventDefault();

    var commentSectionLabel = e.currentTarget.dataset.swCommentTab;
    this.currentMode = commentSectionLabel;

    this.repaint(_.bind(function() {
      this.$(this.swSelectors.commentTabWrapper).removeClass('selected').filter('[' + this.swAttrs.commentTabWrapper + '=' + commentSectionLabel + ']').addClass('selected');
      var $commentSection = this.$(this.swSelectors.commentSection).addClass('hidden').filter('[' + this.swAttrs.commentSection + '=' + commentSectionLabel + ']').removeClass('hidden');

      if ($commentSection.data('swCommentSectionHideForm')) {
        this.$(this.swSelectors.commentFormWrapper).addClass('hidden');
      } else {
        this.$(this.swSelectors.commentFormWrapper).removeClass('hidden');
      }

    }, this));

    sw.trigger('comment-section-selected', commentSectionLabel);
  },

  textChanged: function() {
    if (this.cachedElements.$textInput.val()) {
      this.cachedElements.$textInput.addClass('focus');
    } else {
      this.cachedElements.$textInput.removeClass('focus');
    }
  }

});


module.exports = CommentForm;
